import AppContext from 'App/AppContext';
import PeriodFilter from 'components/Filter/PeriodFilter';
import { AuditCriteriaPeriod } from 'models/auditCriteriaValues';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalStorageKeys } from 'utils/localstorage';
import { toAuditCriteriaPeriod } from './criteriaPeriod';

interface ICriteriaPeriodFilterProps {
  // where the choice is kept: the register's <Register>CriteriaPeriod key, which useCriteriaColumns reads
  storageKey: LocalStorageKeys;
  onPeriodChange: (period: AuditCriteriaPeriod) => void;
}

/**
 * The period of a register's criteria columns (PLAN-CTI-088): the PeriodFilter every register uses for a period, with
 * "Latest answer" as its All option, the choice mapped to the criteria period the API reads.
 */
const CriteriaPeriodFilter = (props: ICriteriaPeriodFilterProps) => {
  const { t } = useTranslation(['criteria']);
  const appContext = useContext(AppContext);

  return (
    <PeriodFilter
      label={t('criteria:Columns.Period.Label')}
      allText={t('criteria:Columns.Period.LatestAnswer')}
      storageKey={props.storageKey}
      showAll
      onUpdatePeriodOption={(data) => props.onPeriodChange(toAuditCriteriaPeriod(data, appContext))}
    />
  );
};

export default CriteriaPeriodFilter;
